module.exports = __webpack_public_path__ + "img/simcard.9229340d.svg";